import { POSTER_PNG_URL } from "../posterAssets";

export function HeroSection() {
  return (
    <section className="hero" id="accueil">
      <div className="hero-copy">
        <h1 className="hero-title">
          Les
          <br />
          Apprentis
          <br />
          Dictateurs
        </h1>
        <p className="hero-text">
          Une comédie politique vive sur l'ivresse du pouvoir, les petites
          ambitions et les grands discours.
        </p>
        <div className="hero-actions">
          <a className="button primary" href="#tournee">
            Voir la tournée
          </a>
          <a className="button secondary" href="#presse">
            Dossier de presse
          </a>
        </div>
      </div>
      <div className="poster-hero" aria-label="Affiche du spectacle">
        <img
          className="poster-image"
          src={POSTER_PNG_URL}
          alt="Affiche du spectacle Les Apprentis Dictateurs"
        />
      </div>
    </section>
  );
}
